module.exports = __webpack_public_path__ + "img/image5.8916b1bc.png";